// Cómo se nombra el cobro registrado en las pantallas de dinero del wizard (contado y enganche).
import {
    NO_CHARGE_LABEL,
    paymentMethodName,
    paymentMethodsLabel,
} from '@/shared/lib/format/salePaymentLines';
import type { RegisteredPayment } from './types';

export { NO_CHARGE_LABEL };

/** Medios del cobro registrado: «Tarjeta + Efectivo»; `null` en un cobro de $0 sin medio. */
export function registeredMethodsLabel(payment: RegisteredPayment): string | null {
    if (payment.payments) return paymentMethodsLabel(payment.payments);
    return payment.method ? paymentMethodName(payment.method) : null;
}
